/**
 * Monthly Occupancy Rate Trend Chart (Highcharts)
 * Line chart showing occupancy % over time
 */
import { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function OccupancyTrendChart({ data = [] }) {
  const options = useMemo(() => {
    if (!data || data.length === 0) {
      return {
        title: { text: 'Monthly Occupancy Rate' },
        subtitle: { text: 'No data available for this period/channel' },
        series: [],
      };
    }

    return {
      chart: {
        type: 'line',
        height: 350,
      },
      title: {
        text: 'Monthly Occupancy Rate',
        style: { fontSize: '16px', fontWeight: '600' },
      },
        subtitle: {
        text: 'Occupancy is nights booked (including owner stays) divided by days in the month. 100% means every night in the month was booked.',
        style: { fontSize: '12px', color: '#666' },
      },
      xAxis: {
        categories: data.map(d => d.month),
        title: { text: 'Month' },
      },
      yAxis: {
        title: { text: 'Occupancy Rate (%)' },
        max: 100,
        labels: {
          formatter: function() {
            return this.value + '%';
          },
        },
      },
      tooltip: {
        backgroundColor: '#ffffff', // Fully opaque white background
        borderColor: '#e5e7eb',
        borderWidth: 1,
        style: {
          color: '#111827', // Dark text for readability
        },
        formatter: function() {
          return '<b>' + this.x + '</b><br/>' +
            'Nights booked (including owner stays): ' + (this.point.booked_nights ?? 0) + '<br/>' +
            'Days in month: ' + (this.point.days_in_month ?? '—') + '<br/>' +
            'Occupancy: <b>' + this.y.toFixed(1) + '%</b>';
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              // Only show labels for values > 10% to avoid clutter
              if (this.y > 10) {
                return this.y.toFixed(0) + '%';
              }
              return '';
            },
            style: {
              fontSize: '11px',
              fontWeight: '500',
              textOutline: '1px contrast',
            },
          },
        },
      },
      series: [{
        name: 'Occupancy Rate',
        data: data.map(d => ({
          y: d.occupancy_rate,
          booked_nights: d.booked_nights,
          active_listings: d.active_listings,
          days_in_month: d.days_in_month,
        })),
        color: '#4A90E2',
        marker: { radius: 4 },
      }],
      credits: { enabled: false },
    };
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
